import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import { fetchProductDetails } from "../productsAPI";

export const useFetchProductDetailsQuery = (productId = 0) => {
  return useQuery({
    enabled: Boolean(productId),
    queryKey: [QUERY_KEYS.GET_PRODUCT_DETAILS, productId],
    queryFn: async () => {
      return fetchProductDetails(productId);
    },
  });
};
